module.exports = __webpack_public_path__ + "img/swiper1.e9636016.png";